import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../components/ui/Button';
import Icon from '../../components/AppIcon';
import { useTheme } from '../../contexts/ThemeContext';

const HomePage = () => {
  const { theme } = useTheme();

  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-grow flex flex-col items-center justify-center px-4 py-20 bg-gradient-to-b from-background to-accent/5">
        <div className="max-w-4xl mx-auto text-center">
          <div className="flex items-center justify-center mb-6 animate-fade-in-up">
            <div className="flex items-center justify-center w-16 h-16 bg-accent rounded-xl">
              <Icon name="Music" size={32} color="white" />
            </div>
          </div>
          
          <h1 className="text-4xl md:text-6xl font-bold mb-6 animate-fade-in-up">
            Bienvenue sur <span className="text-accent">Artis.io</span>
          </h1>
          
          <p className="text-xl md:text-2xl text-muted-foreground mb-8 animate-fade-in-up">
            La plateforme qui connecte artistes, lieux (clubs, festivals, restaurants, événements) et agents professionnels.
          </p>
          
          <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4 justify-center mb-12 animate-fade-in-up">
            <Link to="/register">
              <Button size="lg" variant="accent" className="w-full md:w-auto">
                <Icon name="UserPlus" className="mr-2" />
                S'inscrire
              </Button>
            </Link>
            
            <Link to="/login">
              <Button size="lg" variant="outline" className="w-full md:w-auto">
                <Icon name="LogIn" className="mr-2" />
                Se connecter
              </Button>
            </Link>
          </div>
        </div>

        <div className="max-w-5xl w-full">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
            <div className="bg-card rounded-lg p-6 shadow-md animate-fade-in-up border border-border">
              <Icon name="Users" size={32} className="text-accent mb-4" />
              <h3 className="text-xl font-semibold mb-2">Pour les Artistes</h3>
              <p className="text-muted-foreground">
                Créez un profil professionnel, connectez-vous avec des lieux et des programmateurs, et développez votre carrière.
              </p>
            </div>
            
            <div className="bg-card rounded-lg p-6 shadow-md animate-fade-in-up border border-border">
              <Icon name="MapPin" size={32} className="text-accent mb-4" />
              <h3 className="text-xl font-semibold mb-2">Pour les Lieux</h3>
              <p className="text-muted-foreground">
                Clubs, festivals, restaurants, espaces événementiels : trouvez des artistes adaptés, optimisez votre programmation et développez votre identité.
              </p>
            </div>
            
            <div className="bg-card rounded-lg p-6 shadow-md animate-fade-in-up border border-border">
              <Icon name="BarChart2" size={32} className="text-accent mb-4" />
              <h3 className="text-xl font-semibold mb-2">Pour les Agents</h3>
              <p className="text-muted-foreground">
                Gérez votre portefeuille d'artistes, suivez les commissions et développez votre réseau professionnel.
              </p>
            </div>
          </div>
        </div>
      </div>

      <footer className="bg-muted py-10">
        <div className="max-w-6xl mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div>
              <h4 className="font-semibold mb-4">Artis.io</h4>
              <ul className="space-y-2">
                <li><Link to="/help-documentation" className="text-muted-foreground hover:text-accent">À propos</Link></li>
                <li><Link to="/help-documentation" className="text-muted-foreground hover:text-accent">Fonctionnalités</Link></li>
                <li><Link to="/help-documentation" className="text-muted-foreground hover:text-accent">Tarifs</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Ressources</h4>
              <ul className="space-y-2">
                <li><Link to="/help-documentation" className="text-muted-foreground hover:text-accent">Blog</Link></li>
                <li><Link to="/help-documentation" className="text-muted-foreground hover:text-accent">Guides</Link></li>
                <li><Link to="/help-documentation" className="text-muted-foreground hover:text-accent">FAQ</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Légal</h4>
              <ul className="space-y-2">
                <li><Link to="/help-documentation" className="text-muted-foreground hover:text-accent">Conditions d'utilisation</Link></li>
                <li><Link to="/help-documentation" className="text-muted-foreground hover:text-accent">Politique de confidentialité</Link></li>
                <li><Link to="/help-documentation" className="text-muted-foreground hover:text-accent">Cookies</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Contact</h4>
              <ul className="space-y-2">
                <li><a href="mailto:contact@artis.io" className="text-muted-foreground hover:text-accent">contact@artis.io</a></li>
                <li className="text-muted-foreground">Paris, France</li>
              </ul>
              <div className="flex space-x-4 mt-4">
                <a href="#" className="text-muted-foreground hover:text-accent">
                  <Icon name="Facebook" size={20} />
                </a>
                <a href="#" className="text-muted-foreground hover:text-accent">
                  <Icon name="Instagram" size={20} />
                </a>
                <a href="#" className="text-muted-foreground hover:text-accent">
                  <Icon name="Twitter" size={20} />
                </a>
              </div>
            </div>
          </div>
          <div className="border-t border-border mt-8 pt-8 text-center text-muted-foreground">
            <p>&copy; {new Date().getFullYear()} Artis.io. Tous droits réservés.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
